import {
  ActionIcon,
  Group,
  Switch,
  createStyles,
  rem,
  Modal,
  Text,
  Button,
  Flex,
} from "@mantine/core";
import { IconEdit, IconEye, IconKey, IconTrash } from "@tabler/icons-react";

import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import swal from "sweetalert";
import StaffModal from "../../containers/StaffModal";
import { forgetPassword, removeContractor } from "../../services/auth";
import { removeStaff, updateStaffStatus, getAllStaff } from "../../services/staff";
import { useSelector } from "react-redux";
import MenuDropdown from "../NoteTableRow/MenuDropdown";
import { useNavigate } from "react-router-dom";

const useStyles = createStyles((theme) => ({
  StaffSwitchCell: {
    paddingTop: rem(12),
    paddingBottom: rem(12),
    paddingLeft: 20,
    fontFamily: "Inter",
    height: "100%",
  },
  StaffSwitchBtn: {
    height: "32px",
    width: "61px",
  },
  border: {
    borderLeft: "1px solid #F2F2F2",
  },
  bg1: {
    "& td": {
      background: "#fff",
    },
    cursor: "pointer",
  },
  bg2: {
    "& td": {
      background: "#F9FAFB",
    },
    cursor: "pointer",
  },
}));

const StaffTableRow = ({ row, index, selectedTab }) => {
  const { classes } = useStyles();
  const [view, setView] = useState(false);
  const [active, setActive] = useState(row.active);
  const [opened, { open, close }] = useDisclosure(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const { profile } = useSelector((state) => state?.profile);
  const isAdmin = profile?.user?.id === row?.id;
  const isContractor = row?.role?.toLowerCase() === "contractor";
  const bg = index % 2 === 0;
  const navigate = useNavigate();

  useEffect(() => {
    setActive(row?.active);
  }, [row, active]);

  const handleEditClick = (e) => {
    navigate(`/home/staff/${row?.id}/edit`);
  };

  const handleRowClick = () => {
    navigate(`/home/staff/${row?.id}/view`);
  };

  const handleRemoveContractor = async (contractorId) => {
    const success = await removeContractor(contractorId);
    if (success) {
      getAllStaff(1, true, selectedTab, "");
    }
  };

 

  const updateStatus = async (isChecked) => {
    try {
      setActive(isChecked);
      const rep = await updateStaffStatus(
        { id: row?.id, active: isChecked },
        true,
        selectedTab
      );
      if (!rep?.success) {
        throw new Error("Failed to update staff status");
      }
    } catch (error) {
      setActive((prev) => !prev);
    }
  };

  // Function to handle the switch toggle
  const handleSwitchToggle = () => {
    if (!active) {
      if (row?.isEmailVerified) updateStatus(true);
      else setConfirmationOpen(true);
    } else {
      updateStatus(false);
    }
  };

  const handleConfirmationSubmit = (forceActivate) => {
    setConfirmationOpen(false);
    updateStatus(forceActivate);
  };

  let firstName = row?.firstName;
  let lastName = row?.lastName;

  if (!firstName && row?.name) {
    const [first, ...rest] = row?.name?.split(" ");
    firstName = first;
    lastName = rest?.length ? rest?.join(" ") : "-";
  }

  return (
    <tr
      style={{ cursor: "pointer" }}
      className={bg ? classes.bg2 : classes.bg1}
    >
      <td onClick={handleRowClick}>{firstName || "-"}</td>
      <td onClick={handleRowClick}>{lastName || "-"}</td>
      {/* <td onClick={handleRowClick}>{row?.firstName || row?.name || "-"}</td> */}
      {/* <td onClick={handleRowClick}>{row?.lastName || "-"}</td> */}
      <td onClick={handleRowClick}>
        {row?.facilityId?.map((f) => f?.name)?.join(", ") || "-"}
      </td>
      <td onClick={handleRowClick}>{row?.position || "-"}</td>
      <td onClick={handleRowClick}>{row?.email || "-"}</td>
      <td onClick={handleRowClick} style={{ textTransform: "capitalize" }}>
        {row?.role || "-"}
      </td>
      <td>
        <Switch
          size="md"
          color="yellow"
          checked={active}
          onChange={handleSwitchToggle}
          className={classes.StaffSwitchBtn}
          disabled={isAdmin || isContractor}
        />
      </td>
      <td onClick={handleRowClick}>
        {row?.zipcode || "-"}
      </td>
      {/* <td>
        <ActionIcon
          variant="light"
          onClick={resetPassword}
          // disabled={isAdmin}
        >
          <IconKey />
        </ActionIcon>
      </td> */}
      <td>
        <MenuDropdown
          isNote={false}
          row={row}
          view={handleRowClick}
          isDashboradMode={false}
          startDate={null}
          endDate={null}
          isStaff={true}
          edit={handleEditClick}
          disabled={isAdmin}
          onRemoveContractor={handleRemoveContractor}
        />
      </td>
      {/* <td>
        <Group>
          <ActionIcon
            color="yellow"
            variant="light"
            onClick={() => {
              setView(true);
              open();
            }}
          >
            <IconEye />
          </ActionIcon>
          <ActionIcon
            color="green"
            variant="light"
            onClick={open}
            disabled={isAdmin}
          >
            <IconEdit />
          </ActionIcon>
          <ActionIcon
            color="red"
            variant="light"
            onClick={remove}
            disabled={isAdmin}
          >
            <IconTrash />
          </ActionIcon>
        </Group>
      </td> */}
      <StaffModal
        opened={opened}
        onclose={close}
        title={"Edit Staff"}
        data={row}
        view={view}
        setView={setView}
        selectedTab={selectedTab}
      />
      <Modal
        size="sm"
        opened={confirmationOpen}
        title="Email not verified"
        overlayProps={{ blur: 3 }}
        zIndex={1000}
        onClose={() => setConfirmationOpen(false)}
      >
        <Text>Are you sure you want to activate staff?</Text>
        <Flex gap={10} mt={20} justify={"flex-end"}>
          <Button
            color="red"
            variant="light"
            onClick={() => setConfirmationOpen(false)}
          >
            Cancel
          </Button>
          <Button
            color="yellow"
            variant="filled"
            onClick={() => handleConfirmationSubmit(true)}
          >
            Force Activate
          </Button>
        </Flex>
      </Modal>
    </tr>
  );
};

export default StaffTableRow;
